import { useMemo } from "react";
import { createClassAndCategories, } from "../hooks/Holdings/utils";
import useGetAllHoldingsV4 from "./Holdings/useGetAllHoldingsV4";
export default function usePerformanceGroupHoldingsV4(groupId, authConfig) {
    const response = useGetAllHoldingsV4(groupId, authConfig);
    return useMemo(() => {
        if (response.isLoading || response.hasError) {
            return response;
        }
        return {
            data: {
                categories: createClassAndCategories(response.data.finmasonHoldingsBreakdown, response.data.taxLots),
            },
            isLoading: false,
            hasError: false,
        };
    }, [response]);
}
//# sourceMappingURL=usePerformanceGroupHoldingsV4.js.map